import { config } from "@/config";
import { useFlow } from "@frigade/react";
import * as Frigade from "@frigade/react";
import { OnboardingSteps } from "../OnboardingGuide";
import OnboardingFlow from "./OnboardingFlow";

const OnboardingRubricViewHint = () => {
  const { flow } = useFlow(config.frigade.flows.gettingStarted);
  const { flow: rubricFlow } = useFlow(config.frigade.flows.rubricViewHint);
  const { flow: readerFlow } = useFlow(config.frigade.flows.readerAnnouncement);
  const currentStep = flow?.getCurrentStep();

  if (
    !rubricFlow?.isCompleted &&
    (currentStep?.id as OnboardingSteps) === "generate_report" &&
    readerFlow?.isCompleted
  ) {
    return (
      <OnboardingFlow>
        <Frigade.Tour
          flowId={config.frigade.flows.rubricViewHint}
          defaultOpen={true}
          alignOffset={19}
        />
      </OnboardingFlow>
    );
  }
};

export default OnboardingRubricViewHint;
